import { TitleCasePipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output
} from '@angular/core';
import { FeatureDetail } from '../../../typings/features/feature-detail';

@Component({
  selector: 'jmkw-disambiguation-section',
  standalone: true,
  imports: [],
  templateUrl: './disambiguation-section.component.html',
  styleUrl: './disambiguation-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DisambiguationSectionComponent {
  private _section!: string;
  @Input() set section(value: string) {
    this._section = new TitleCasePipe().transform(value + 's');
  }
  get section(): string {
    return this._section;
  }
  @Input() candidates!: FeatureDetail[];
  @Output() selection: EventEmitter<FeatureDetail> =
    new EventEmitter<FeatureDetail>();

  select(item: FeatureDetail) {
    this.selection.emit(item);
  }
}
